import { CSSProperties } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { IDataRequestSummary } from '@vivli/features/data-requests/infrastructure/interface';
import { DTIDataRequest } from '@vivli/shared/infrastructure/constants';

const titleStyle: CSSProperties = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 600
};

interface DataRequestTitleRendererComponentProps extends ICellRendererParams {
    data: IDataRequestSummary;
}

// DEV-958: the Data Request Title cell. The title attribute shows the full text on hover and is what
// the Selenium page object clicks to open a request; the test id is what it reads the titles by.
export const DataRequestTitleRendererComponent = ({ data }: DataRequestTitleRendererComponentProps) => (
    <div title={data.requestTitle} style={titleStyle} data-test-id={DTIDataRequest.DataRequestTitle + data.requestTitle}>
        {data.requestTitle}
    </div>
);
